import { DateTime } from "luxon";
import { Platform } from "react-native";
import { WebDateSelector } from "@/src/components/mobile/WebDateSelector/WebDateSelector";
import DateTimePicker, {
  DateTimePickerEvent,
} from "@react-native-community/datetimepicker";
import { getActiveSystemLocale } from "@/src/OS/getActiveLocale";
import { Box, TouchableBox , AHText } from "arkh";
import { useState } from "react";

function ListItemRightDateTimeAndroid(props: {
  disabled?: boolean;
  isAllDay: boolean;
  date: DateTime;
  setDate: (date: DateTime) => void;
  tz: string;
}) {
  const [openDate, setOpenDate] = useState(false);
  const [openTime, setOpenTime] = useState(false);
  const onChange = (f: DateTimePickerEvent, selectedDate: Date | undefined) => {
    setOpenDate(false);
    setOpenTime(false);
    if (selectedDate) {
      props.setDate(DateTime.fromJSDate(selectedDate));
    }
  };
  return (
    <>
      <Box
        style={{
          flexDirection: "row",
        }}
      >
        <TouchableBox
          color={props.disabled ? undefined : "surface-backgroundControl"}
          cornerRadius="medium"
          space="small"
          disabled={props.disabled}
          onPress={() => {
            setOpenDate(true);
          }}
        >
          <AHText type="subtitle" color="text-primary">
            {props.date.toLocaleString({
              ...DateTime.DATE_SHORT,
              timeZone: props.tz,
            })}
          </AHText>
        </TouchableBox>
        {!props.isAllDay ? (
          <>
            <Box space="small" />
            <TouchableBox
              color={props.disabled ? undefined : "surface-backgroundControl"}
              cornerRadius="medium"
              space="small"
              disabled={props.disabled}
              onPress={() => {
                setOpenTime(true);
              }}
            >
              <AHText type="subtitle" color="text-primary">
                {props.date.toLocaleString({
                  ...DateTime.TIME_24_SIMPLE,
                  timeZone: props.tz,
                })}
              </AHText>
            </TouchableBox>
          </>
        ) : null}
      </Box>
      {openDate ? (
        <DateTimePicker
          mode="date"
          onChange={onChange}
          value={props.date.toJSDate()}
          minimumDate={new Date()}
        />
      ) : null}
      {openTime ? (
        <DateTimePicker
          mode="time"
          onChange={onChange}
          value={props.date.toJSDate()}
          minimumDate={new Date()}
        />
      ) : null}
    </>
  );
}

export function ListItemRightDateTime(props: {
  placeholder: React.ReactNode;
  isAllDay: boolean;
  date: DateTime;
  setDate: (date: DateTime) => void;
  disabled?: boolean;
  tz: string;
}) {
  if (Platform.OS === "web") {
    return (
      <WebDateSelector
        disabled={props.disabled}
        type={props.isAllDay ? "date" : "datetime"}
        timezone={props.tz}
        placeholder={props.placeholder}
        value={props.date}
        onChangeValue={(date) => {
          if (date) {
            props.setDate(date);
          }
        }}
        color="text-primary"
      />
    );
  }
  if (Platform.OS === "ios") {
    const systemLocale = getActiveSystemLocale();
    return (
      <DateTimePicker
        disabled={props.disabled}
        themeVariant="light"
        value={props.date.toJSDate()}
        mode={props.isAllDay ? "date" : "datetime"}
        display="compact"
        locale={systemLocale}
        timeZoneName={props.tz}
        onChange={(_, selectedDate) => {
          if (selectedDate) {
            props.setDate(DateTime.fromJSDate(selectedDate));
          }
        }}
      />
    );
  }
  if (Platform.OS === "android") {
    return (
      <ListItemRightDateTimeAndroid
        disabled={props.disabled}
        isAllDay={props.isAllDay}
        setDate={props.setDate}
        date={props.date}
        tz={props.tz}
      />
    );
  }
  return null;
}
